import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React, { useEffect } from 'react';
import { withTheme } from '@material-ui/core/styles';
import BouncedEmails from './Components/BouncedEmails';
import Queue from './Components/Queue';
import { Page } from 'ecrion-components';
import Form from '../../../form';

var trimChar = function trimChar(string, charToRemove) {
  while (string.charAt(0) == charToRemove) {
    string = string.substring(1);
  }

  while (string.charAt(string.length - 1) == charToRemove) {
    string = string.substring(0, string.length - 1);
  }

  return string;
};

var EmailPage = function EmailPage(_ref) {
  var theme = _ref.theme,
      history = _ref.history,
      onClose = _ref.onClose,
      location = _ref.location,
      queuePath = _ref.queuePath,
      bouncedEmailsPath = _ref.bouncedEmailsPath,
      rest = _objectWithoutProperties(_ref, ["theme", "history", "onClose", "location", "queuePath", "bouncedEmailsPath"]);

  useEffect(function () {
    document.title = 'Settings � Email � Ecrion';
  }, []);
  var icon = null;

  if (history || onClose) {
    icon = {
      type: 'close',
      onClick: undefined
    };

    if (history) {
      icon.onClick = function () {
        return history && history.return && history.return('/settings');
      };
    } else if (onClose) {
      icon.onClick = onClose;
    }
  }

  var showBouncedEmails = location.pathname.startsWith(bouncedEmailsPath);
  var trialLicense = Page.Licensing.useLicense();
  var queue = 'Default';

  if (!showBouncedEmails) {
    queue = location.pathname.replace(queuePath, '');
    queue = trimChar(queue, '/');
  }

  if (!queue) queue = 'Default';
  return React.createElement(React.Fragment, null, React.createElement(Page.ToolBar, {
    icon: icon,
    leftChildren: showBouncedEmails ? 'Bounced Emails' : "".concat(queue, " - Email Configuration"),
    color: "navbar"
  }), React.createElement(Page.Common, null, showBouncedEmails ? React.createElement(BouncedEmails, rest) : trialLicense.IsTrial ? React.createElement(Form.Error, null, "This feature is not available in Trial Mode") : React.createElement(Queue, Object.assign({
    queue: queue,
    history: history
  }, rest))));
};

EmailPage.defaultProps = {
  onClose: null
};
export default withTheme(EmailPage);